import { useRef } from 'react';
import { useTableScrollerContext } from './useTableScroller';

export const useSyncScrollRef = () => {
  const { handleAddRefToSyncScroll, handleRemoveRefFromSyncScroll } = useTableScrollerContext();
  const registeredElement = useRef<HTMLDivElement | null>(null);

  return (element: HTMLDivElement | null) => {
    if (element) {
      registeredElement.current = element;
      handleAddRefToSyncScroll(element);
      return;
    }

    if (registeredElement.current) {
      handleRemoveRefFromSyncScroll(registeredElement.current);
      registeredElement.current = null;
    }
  };
};
